import { Report } from '@material-ui/icons';
import React from 'react';
import Button from '../Button/Button';
import Text from '../Text';

const ErrorBoundaryFallback = ({ error, resetErrorBoundary }) => {

    React.useEffect(() => {
        console.log(error);
    }, [error])

    return (
        <div role="alert" style={{ margin: '1rem 0' }}>
            <Text variant="h3">
                There was an error loading this area.&nbsp;
                <Text
                    variant='span'
                    ascent="primary"
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.location.reload()}
                >Reload this page.</Text></Text>
            <Button style={{ marginTop: '1rem' }} onClick={resetErrorBoundary}><Report style={{ marginRight: '0.25rem' }} />Report feedback</Button>
        </div>
    )
}

export default ErrorBoundaryFallback
